import loadable from "@loadable/component";
import CreateIcon from "../../../Icons/Create";
import APIS from "../../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../../customHooks/useFleetServicePatchHook";
import useGetHook from "../../../customHooks/useFleetServiceGetHook";

const EditVehicleComponent = loadable(
  () => import("../../../components/Settings/Vehicle/EditVehicle")
);
const EditVehicle = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: ["vehicle"],
    url: `${APIS.VEHILCE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["vehicle"],
    navigateURL: "/vehicle",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Vehicle</span>
      </div>
      <EditVehicleComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditVehicle;
